<mat-dialog-content>
  <form [formGroup]="modifyForm">
    <h2>
      <strong>{{ 'Modify' | translate }}</strong>
    </h2>
    <div class="text-margin">
      <span
        ><strong>{{ 'Document Type' | translate }}:</strong></span
      >
      <input
        readonly
        class="form-control"
        type="text"
        placeholder="{{ 'Document Type' | translate }}"
        formControlName="document_type"
      />
      @if (textValid('document_type')) {
        <span class="form-text text-danger">{{
          'You must type valid account' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Inventory' | translate }}:</strong></span
      >
      <input
        class="form-control"
        type="text"
        placeholder="{{ 'Inventory' | translate }}"
        formControlName="inventory"
      />
      @if (textValid('inventory')) {
        <span class="form-text text-danger">{{
          'You must type valid account' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Service' | translate }}:</strong></span
      >
      <input
        maxlength="12"
        class="form-control"
        type="text"
        placeholder="{{ 'Service' | translate }}"
        formControlName="service"
      />
      @if (textValid('service')) {
        <span class="form-text text-danger">{{
          'You must type valid account' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Tax' | translate }}</strong></span
      >
      <input
        maxlength="12"
        class="form-control"
        type="text"
        placeholder="{{ 'Tax' | translate }}"
        formControlName="tax"
      />
      @if (textValid('tax')) {
        <span class="form-text text-danger">{{
          'You must type valid account' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Withholding Tax' | translate }}:</strong></span
      >
      <input
        maxlength="12"
        class="form-control"
        type="text"
        placeholder="{{ 'Withholding' | translate }}"
        formControlName="withholding"
      />
      @if (textValid('withholding')) {
        <span class="form-text text-danger">{{
          'You must type valid account' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Ica' | translate }}:</strong></span
      >
      <input
        maxlength="12"
        class="form-control"
        type="text"
        placeholder="{{ 'Ica' | translate }}"
        formControlName="ica"
      />
      @if (textValid('ica')) {
        <span class="form-text text-danger">{{
          'You must type valid account' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Total' | translate }}:</strong></span
      >
      <input
        maxlength="12"
        class="form-control"
        type="text"
        placeholder="{{ 'Total' | translate }}"
        formControlName="total"
      />
      @if (textValid('total')) {
        <span class="form-text text-danger">{{
          'You must type valid account' | translate
        }}</span>
      }
    </div>
    <div class="row" id="buttons-div">
      <div class="col" id="buttons">
        <button (click)="update()" mat-raised-button>
          {{ 'Update' | translate }}
        </button>
      </div>
      <div class="col" id="buttons">
        <button mat-raised-button [mat-dialog-close]>
          {{ 'Cancel' | translate }}
        </button>
      </div>
    </div>
  </form>
</mat-dialog-content>
